import React, { useRef } from "react";
import styles from "./Home.module.css";

import Header from "./components/Header";
import Hints from "./components/Hints";
import Products from "./components/Products";
import Blogs from "./components/Blogs";
import Customers from "./components/Customers";
import Pricing from "./components/Pricing";
import Contents from "./components/Contents";
import Softwares from "./components/Softwares";

function HomePage() {
  const containerRef = useRef(null);

  return (
    <>
      <div className={`${styles.HomePageCont}`} ref={containerRef}>
        <div className={`${styles.HomePage} `}>
          <Header />
          <div className={`${styles.AboutUs}`}>
            <h2>درباره نیکان</h2>
            <div className={`${styles.AboutUsContent}`}>
              <img
                src="\TfnikanSolid.svg"
                alt="tf nikan - توسعه فناوری نیکان"
              />
              <p>
                شرکت توسعه فناوری نوین افزار نیکان در سال ۱۳۹۲ با شماره ثبت
                ۴۶۶۶۶۶ تأسیس شد و از همان ابتدا مأموریت خود را بر توسعه
                راهکارهای هوشمند در حوزه مدیریت ناوگان، لجستیک و اینترنت اشیا
                متمرکز کرد. این شرکت با ارائه مجموعه‌ای کامل از نرم‌افزارهای
                تخصصی و سخت‌افزارهای ردیاب GPS، راهکاری جامع برای نظارت، کنترل و
                بهینه‌سازی ناوگان و زیرساخت‌های هوشمند در اختیار سازمان‌ها و
                صنایع قرار داده است. ترکیب فناوری نرم‌افزاری پیشرفته با
                دستگاه‌های سخت‌افزاری معتبر، امکان ارتقای بهره‌وری، افزایش امنیت
                رانندگان و بار، و توسعه زیرساخت‌های هوشمند را برای مشتریان فراهم
                می‌سازد.
              </p>
            </div>
          </div>
          <Softwares />
          <Contents />
          <Pricing />
          {/* <Hints /> */}
          <Products />
          {/* <Blogs /> */}
          <Customers />
        </div>
      </div>
    </>
  );
}

export default HomePage;
